<template>
    <div>
        <i v-icon="['carrierTypeConvert', model.type + 1]"></i>
        {{ model[index] }}
    </div>
</template>
<script>
export default {
    props: ['model', 'index'],
    mounted() {

    }
}
</script>
<style scoped lang="scss"></style>